// The in-fiction mirror of the docs page, shown to people who are signed in:
// the same sections in the same order, told by the narrator, the reader's
// alt self from the universe that created Omniu (their name and face, wearing
// the tenant creator's style). Written in Eric's voice for Eric to edit.
// {name} is the reader's first name and {names} its plural ({name}+"es" after
// s, x, z, ch or sh, else +"s"); {world} is the reader's world ID. Blank lines
// split paragraphs.
//
// The mirror only turns on once every section has a head and a body; until
// then docs.html?fiction previews it with the gaps marked.

export type FictionSection = { id: string; toc: string; head: string; body: string };

export const FICTION: FictionSection[] = [
  {
    id: 'overview', toc: 'be everywhere', head: 'be everywhere',
    body: 'You must be {name} {world}\n\n'
      + "I am you, from the universe that created Omniu. You can call me {name}. I created this app to help {names} like you reach their goals, and now I'm asking you to pay it forward, and help all the {names} succeed across the multiverse.\n\n"
      + "Here's how it all works, the way I see it from over here.",
  },
  {
    id: 'concepts', toc: 'how it works', head: 'how the multiverse works',
    body: 'Every goal you set splits off a future you, someone who already got there. They work back and draw you forward.\n\n'
      + 'Milestones are the stops along the way, in order. Tasks are just something you complete for the sake of milestones. Check one off and it shows up behind you as a purple dot. Conclude a milestone and it turns gold.\n\n'
      + "Behind you is everything you've done. Tap any of it to open your journal. Ahead of you, a line runs out to each of your future selves.\n\n"
      + 'There are no deadlines here. Nothing is ever late. If a goal stops fitting, let it go and set a new one. No hard feelings, I promise.',
  },
  {
    id: 'by-hand', toc: 'do it yourself', head: 'do it yourself',
    body: "Open a goal and your future self has the plan. Hit + to add a milestone, or + under one to add a task. The pencil lets you rename things. The ✕ lets you delete.\n\n"
      + "Tap a task's circle when you do it. Tap again if you didn't. When you hit a milestone, conclude it.\n\n"
      + 'You can always edit by hand if you prefer.',
  },
  {
    id: 'connect', toc: 'bring your agent', head: 'bring your own agent',
    body: "But I recommend connecting your favorite AI agent. It'll have all your context of what comes next.\n\n"
      + "Add Omniu to Claude, ChatGPT or whatever you use, sign in and say yes. Then just ask it to set up milestones.",
  },
  {
    id: 'talk', toc: 'talk it out', head: 'talk it out',
    body: "Or, we can talk it out and I'll help you put a plan together. I'm not quite ready for that one yet. Soon.",
  },
  {
    id: 'tools', toc: 'what your agent can do', head: 'what your agent can do',
    body: 'Your agent can do anything you can do in the app, on your goals and nothing else. It can read your goals, plan them out, rename things and check things off.\n\n'
      + 'Before it deletes something or ends a goal, it asks you first.',
  },
  {
    id: 'examples', toc: 'things to ask', head: 'things to ask',
    body: "Try \"set up milestones\". Or \"What can I do today?\" Or \"I went for a run, check it off.\"\n\n"
      + "Ask \"How am I doing on my marathon goal?\" or \"Show me everything I've accomplished this month.\"",
  },
  {
    id: 'access', toc: 'who gets in', head: 'who gets in',
    body: "You sign in with Google. When an agent wants in, it sends you to omniu.me to say yes, and you'll see exactly what it'll be able to do.\n\n"
      + "It only ever sees your stuff, and only after you say so. Changed your mind? Disconnect it from your profile or from the agent's settings.",
  },
  {
    id: 'social', toc: 'alternate selves', head: 'inspire alternate selves',
    body: "Everyone else in Omniu is a version of you from another universe. Same face, different style. These are distant variants. Born in another place and time, and following their own destinies.\n\n"
      + "Open Social and I'll take you back to where all of us started. Everything you see out there is what other {names} have shared. Tap one to read it and leave a reaction.\n\n"
      + "When you conclude something, you can share it from your journal. You can choose exactly what to share, and you can edit and unshare it later.",
  },
  {
    id: 'support', toc: 'find me', head: 'find me',
    body: 'Something broken, or just want to say hi? Write to us@omniu.me. It comes straight to me.',
  },
];

export const fictionReady = () => FICTION.every((s) => s.head.trim() && s.body.trim());
